import { Fragment, useState } from 'react';
import cx from 'classnames';

/**
 * Header-Search — Phase-1 Stub. Hookt sich in eine Folge-Implementierung
 * (Customer-Quick-Search, Ticket-ID-Lookup) ein. Vorerst nur Visual.
 */
export default function SearchBox() {
  const [active, setActive] = useState(false);

  return (
    <Fragment>
      <div className={cx('search-wrapper', { active })}>
        <div className="input-holder">
          <input
            type="text"
            className="search-input"
            placeholder="Quick-Search (coming in Phase 2)…"
            disabled
          />
          <button
            type="button"
            aria-label={active ? 'Suche schließen' : 'Suche öffnen'}
            className="search-icon"
            onClick={() => setActive((v) => !v)}
          >
            <span />
          </button>
        </div>
        <button
          type="button"
          aria-label="Suche zurücksetzen"
          className="close"
          onClick={() => setActive(false)}
        />
      </div>
    </Fragment>
  );
}
